import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Form, Popconfirm, Tooltip } from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formHasErrors, formIsTouched } from '../../../utils/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskDrawerFooter = function TaskDrawerFooter(_ref) {
  var isCreating = _ref.isCreating,
      isLoading = _ref.isLoading,
      createAnother = _ref.createAnother,
      setCreateAnother = _ref.setCreateAnother,
      form = _ref.form,
      onDeletionConfirmed = _ref.onDeletionConfirmed;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getAuthStore = getAuthStore(),
      canManageTasks = _getAuthStore.canManageTasks;

  return /*#__PURE__*/_jsxs(Container, {
    className: "ant-drawer-footer",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "actions-left",
      children: [!isCreating && canManageTasks && /*#__PURE__*/_jsx(Popconfirm, {
        getPopupContainer: function getPopupContainer(trigger) {
          return trigger.parentElement;
        },
        title: t('areYouSure'),
        icon: /*#__PURE__*/_jsx(QuestionCircleOutlined, {
          style: {
            color: 'red'
          }
        }),
        okText: t('yes'),
        cancelText: t('cancel'),
        onConfirm: onDeletionConfirmed,
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          danger: true,
          disabled: isLoading,
          children: t('delete')
        })
      }), isCreating && /*#__PURE__*/_jsxs("div", {
        className: "create-another",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          id: "createAnother",
          checked: createAnother,
          onChange: function onChange(ev) {
            return setCreateAnother(ev.target.checked);
          }
        }), /*#__PURE__*/_jsx("label", {
          className: "create-another-label",
          htmlFor: "createAnother",
          children: t('createMore.label')
        }), /*#__PURE__*/_jsx(Tooltip, {
          color: "purple",
          title: t('createMore.help'),
          children: /*#__PURE__*/_jsx(InfoCircleOutlined, {})
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "actions-right",
      children: /*#__PURE__*/_jsx(Form.Item, {
        shouldUpdate: true,
        validateFirst: true,
        children: function children() {
          return /*#__PURE__*/_jsx(Button, {
            type: "primary",
            disabled: isLoading || !formIsTouched(form) || formHasErrors(form),
            loading: isLoading,
            htmlType: "submit",
            onClick: form.submit,
            children: t('save')
          });
        }
      })
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Footer__Container",
  componentId: "sc-3z5irn-0"
})(["&.ant-drawer-footer{position:absolute;right:0;bottom:0;left:0;background:white;z-index:1000;.actions-left{float:left;}.actions-right{float:right;}.create-another{padding:5px;.create-another-label{margin-right:3px;margin-left:6px;}}.ant-form-item{margin-bottom:0 !important;}}"]);